// extracted by mini-css-extract-plugin
export default {"mainLayout":"App_main-layout__wVsIE","subLayout":"App_sub-layout__N5kR7","content":"App_content__naSmy"};